import { render, staticRenderFns } from "./prize-viewer.vue?vue&type=template&id=39d489f0&"
import script from "./prize-viewer.vue?vue&type=script&lang=js&"
export * from "./prize-viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports